module.exports = __webpack_public_path__ + "img/photos/bg/header.jpg";